import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, ViewChild, ElementRef, Input, SimpleChanges, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { first } from 'rxjs/operators';
import { User, Category, CategoryNode } from '../_models';
import { AuthenticationService } from '../_services/authentication.service';
import { CategoryService } from '../_services/category.service';
import { DocumentService } from '../_services/document.services'
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { AlertService } from '../_services/alert.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Documentcategory } from '../_models/documentcategory';
import { MatDialog } from '@angular/material/dialog';
import { DialogUploadfileComponent } from './dialog-uploadfile/dialog-uploadfile.component';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SelectionModel } from '@angular/cdk/collections';
import { AppConfig } from 'src/assets/config/config/app-config';
import { Document } from 'src/app/_models/document';

import cloneDeep  from 'lodash/cloneDeep';

import { DialogDeleteConfirmComponent } from 'src/app/dialog-delete-confirm/dialog-delete-confirm.component';

interface CategoryFlatNode {
  expandable: boolean;
  id: number;
  name: string;
  level: number;
}

@Component({
  selector: 'app-categories',
  templateUrl: 'categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  currentUser: User;
  categories = [];
  documents: Documentcategory = null;
  selectedRow: Array<JSON> = []
  documentCount: number = 0;
  documentCols: String[] = [];
  docResultsList: MatTableDataSource<any>;
  selectedDoc: String;
  selectedCategory: Boolean = false;
  documentResults: Array<JSON> = [];
  categoryId: String;
  categoryName: String;
  width = "100";
  appError: String = "";
  hideDocList: Boolean = false;
  filterValue: string;
  openUpload: boolean = false;
  openVersionUpload: boolean = false;
  openMetaData: boolean = false;
  hideDocView: Boolean = false;
  isDocLocked: boolean = false;
  isLockUser: boolean = false;
  offset: number = 0;
  loadNext: boolean = false;
  totalDocumentCount: number = 0;
  selectDocument:any;
  //documentCount: number;
  category: any;
  loadPrevious: boolean = false;
  allCategories = []
  categoryPermissions: any
  noDocuments: boolean = false;
  noCategories: boolean = false;
  selection = new SelectionModel<any>(true, []);
  url: string;
  fileToUpload: File = null
  enableImageTrust: boolean = this.config.getConfig("enableImageTrust")

  restrictUpdDelGrp: string = this.config.getConfig("restrictUploadDeleteGroup");

  allSelectedDocuments = [];
  numOfSelectedDocuments: number = 0;
  allowFileSelectFromOtherCategories: boolean = this.config.getConfig("allowFileSelectFromOtherCategories");
  tempMessage = null;
  filterInput: string = "";
  lockedDocs = []
  disableUpload: boolean = true;
  disableDelete: boolean = true;
  isAdmin: boolean = false;

  aclGroup: any = this.config.getACLGroup();

  pageSize = 50;
  pageIndex = 0;
  currentPageSize = 0;
  currentStartPageIndex = 0;  
  activeDocumentDetails: Document = null;

  selectedFormDisplayList = []
  systemAttrDisplayList = []
  visibleFields = ["Document Type", "Key Date", "Subject", "Water Right ID"];


  sort;
  @ViewChild(MatDrawerContainer) drawerContainer: MatDrawerContainer;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.docResultsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator && this.docResultsList) {
      this.docResultsList.paginator = this.paginator;
    }
  }

  private _transformer = (node: CategoryNode, level: number) => {
    return {
      expandable: !!node.sub_categories && node.sub_categories.length > 0,
      id: node.id,
      name: node.name,
      level: level,
    };
  }

  @ViewChild('redactionPopup', { static: false }) redactionPopup: TemplateRef<any>;

  treeControl = new FlatTreeControl<CategoryFlatNode>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level, node => node.expandable, node => node.sub_categories);

  categoryTreeData = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  navBarCategories: any[]
  constructor(
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private categoryService: CategoryService,
    private documentService: DocumentService,
    public dialog: MatDialog,
    private cdref: ChangeDetectorRef,
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer,
    private config: AppConfig
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    //this.dataSource.data = TREE_DATA;
    this.matIconRegistry.addSvgIcon(
      'pdf',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/pdf.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'jpeg',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/jpg.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'ppt',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/ppt.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xls',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/xls.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'txt',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/txt.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'doc',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/doc.svg')
    );
  }
  hasChild = (_: number, node: CategoryFlatNode) => node.expandable;

  ngOnInit() {
    //this.loadAllCategories();
    this.isAdmin = JSON.parse(localStorage.getItem("isAdmin"))
    this.getAllCategories();
    if (this.allowFileSelectFromOtherCategories) {
      this.documentService.getAllSelectedDocuments().subscribe(docs => {
        this.allSelectedDocuments = docs;
        this.numOfSelectedDocuments = this.allSelectedDocuments.length;
        this.allSelectedDocuments.forEach(doc => {
          this.selection.select(doc);
          //this.ngAfterContentChecked();
        });
      })
    }
    //console.log("Drawer " + drawer);
  }

  ngAfterContentChecked() {
    //this.selectedRow = undefined
    this.cdref.detectChanges();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.docResultsList.data.length;
    if (this.allowFileSelectFromOtherCategories) {
      let count = 0;
      for (let i = 0; i < this.documents.results.length; i++) {
        if (this.allSelectedDocuments.indexOf(this.documents.results[i].documentId) === -1) {
          return false;
        }
        count++;
      }
      return count === numRows;
    }
    return numSelected === numRows;
  }

  getDisplayListData() {
    var ignoreListForMetadata = ["Document ID", "Document Title", "Document Version", "Created By", "Creation Date", "File Type", "Modified By", "Modified Date", "Size", "Source"];
    this.selectedFormDisplayList = [
      { name: "Document ID", value: "documentId", visible: false, type: "original", data_type: "str"},
      { name: "Document Title", value: "documentName", visible: false, type: "original", data_type: "str"},
      { name: "Document Version", value: "VersionNumber", visible: false, type: "original", data_type: "str"},      
      { name: "Creation Date", value: "createdDate", visible: false, type: "original", data_type: "str"},
      { name: "Created By", value: "created_by", visible: false, type: "original", data_type: "str"},
      { name: "Modified Date", value: "modifiedDate", visible: false, type: "original", data_type: "str"},
      { name: "Modified By", value: "modified_by", visible: false, type: "original", data_type: "str"},
      { name: "Document Source", value: "Source", visible: false, type: "properties", data_type: "str"}
    ]
    for (let category of this.allCategories) {
      for (let metaData of category.meta_data_definition) {
        if (metaData.active) {
          for (let property of metaData.properties) {
            var obj = {}
            if (property.name && !ignoreListForMetadata.includes(property.name.trim())) {
              obj["name"] = property.name.trim()
              obj["value"] = property.name.trim()
              obj["data_type"] = property.data_type
              obj["type"] = "properties"
              if (this.visibleFields.includes(property.name)) {
                obj["visible"] = true;
              } else {
                obj["visible"] = false;
              }
              this.selectedFormDisplayList.push(obj)
            } else {
              console.log(property.name)
            }
          }
        }
      }
    }
    this.systemAttrDisplayList = [
      { name: "File Type", value: "type", visible: false, type: "system" },
      { name: "Size", value: "size" , visible: false, type: "system"}      
    ]
    for (let property of this.systemAttrDisplayList) {
      var obj = {}
      obj["name"] = property.name
      obj["value"] = property.value
      obj["type"] = property.type
      obj["data_type"] = "str"
      obj["visible"] = property.visible
      this.selectedFormDisplayList.push(obj)
    }
    this.selectedFormDisplayList = this.removeDuplicateFromDisplayList(this.selectedFormDisplayList, "name");
    this.selectedFormDisplayList = this.sortDisplayList(this.selectedFormDisplayList, "name");
    var additionalColsStr= localStorage.getItem('additionalColumns');    
    if (additionalColsStr) {
      var additionalColsList = JSON.parse(additionalColsStr);
      if (additionalColsList && additionalColsList.length > 0) {
        additionalColsList.forEach(colName => {
          let selectedItem = this.selectedFormDisplayList.filter(selectedForm => selectedForm["name"] === colName);
          if (selectedItem.length > 0) {
            selectedItem[0]["visible"] = true;
          }
        });
      }
    }
  }

  applyShowHideColumns() {
    var additionalCols: String[] = []
    this.documentCols = []
    this.documentCols.push("select");
    var additionalColumnsStorageList = [];
    this.selectedFormDisplayList.forEach(function (key) {
      if (key.visible) {
        additionalCols.push(key.name);        
      }
    });

    additionalCols.forEach((colName:string) => {
      if (!this.visibleFields.includes(colName)) {
        additionalColumnsStorageList.push(colName);
      }
    });

    localStorage.setItem('additionalColumns', JSON.stringify(additionalColumnsStorageList));


    for (var i = 0; i < additionalCols.length; i++) {
      this.documentCols.push(additionalCols[i])
    }
    this.documentCols.push("actionButton");
  }

  removeDuplicateFromDisplayList = (array, key) => {
    var check = new Set();
    return array.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
  }

  sortDisplayList = (array, key) => {    
    return array.sort((a, b) => {
      return a[key].localeCompare(b[key]);
    });
  }

  documentSelected(event?, docId?, allClear = false, allSelected = false) {
    //console.log(event, docId, allClear, allSelected);
    if (allClear) {
      let clearDocs = [];
      for (let i = 0; i < this.documents.results.length; i++) {
        clearDocs[i] = this.documents.results[i].documentId;
      }
      this.documentService.removeDocumentsFromSelectedDocuments(clearDocs);
      return;
    }
    if (allSelected) {
      this.documentService.addDocumentsToSelectedDocuments(this.selection.selected);
      return;
    }
    if (event['checked']) {
      this.documentService.addDocumentToSelectedDocuments(docId);
    } else if (event['checked'] === false) {
      this.documentService.removeDocumentFromSelectedDocuments(docId);
    }
  }

  isDocumentSelected(docId) {
    for (let i = 0; i < this.allSelectedDocuments.length; i++) {
      if (docId == this.allSelectedDocuments[i]) {
        return true;
      }
    }
    return false;
  }

  removeAllSelectedDocs() {
    this.selection.clear();
    this.documentService.removeAllDocumentsFromSelectedDocuments();
  }

  calcIndeterminate() {
    for (let i = 0; i < this.documents.results.length; i++) {
      if (this.allSelectedDocuments.indexOf(this.documents.results[i].documentId) != -1) {
        return true;
      }
    }
    return false;
  }

  masterToggle(ref) {
    if (this.isSomeSelected()) {
      this.selection.clear();
      ref.checked = false;
      this.allowFileSelectFromOtherCategories ? this.documentSelected(null, null, true, false) : null;
    } else {
      if (this.allowFileSelectFromOtherCategories) {
        if (this.isAllSelected()) {
          this.selection.clear();
          this.documentSelected(null, null, true, false);
        } else {
          this.selecteAll();
          this.documentSelected(null, null, false, true);
        }
      } else {
        this.isAllSelected() ?
          this.selection.clear() :
          this.selecteAll();
      }
    }
  }


  selecteAll() {
    if (this.filterValue) {
      this.docResultsList.filter = this.filterValue.trim().toLowerCase();
      this.docResultsList.filteredData.forEach(row => {
        this.selection.select(row.documentId)
      });
    }
    else {
      this.docResultsList.data.forEach(row => this.selection.select(row.documentId));
    }
  }

  isSomeSelected() {
    //console.log("Some Selected: " + this.selection.selected);
    if (this.allowFileSelectFromOtherCategories) {
      let count = 0;
      for (let i = 0; i < this.documents.results.length; i++) {
        if (this.allSelectedDocuments.indexOf(this.documents.results[i].documentId) != -1) {
          count++;
        }
      }
      return count > 0;
    }
    return this.selection.selected.length > 0;
  }


  mergeDocuments() {
    if (this.selection.selected.length > 1) {
      var apiUrl = this.config.getConfig("apiUrl")
      if (apiUrl === "https://km0gvq0iu0.execute-api.us-east-2.amazonaws.com/dev") {
        this.url = `http://in-ith-web.s3-website.us-east-2.amazonaws.com/docuedge-imagetrust-operations.html?&docId=${this.selection.selected.join()}&dms_user=${this.currentUser.username}&token=${this.currentUser.token}&environment=DocuEdge-Dev`
        window.open(this.url, "_blank");
      }
      else if (apiUrl === "https://il4p364yh4.execute-api.us-east-2.amazonaws.com/dev") {
        this.url = `http://in-ith-web.s3-website.us-east-2.amazonaws.com/docuedge-imagetrust-operations.html?&docId=${this.selection.selected.join()}&dms_user=${this.currentUser.username}&token=${this.currentUser.token}&environment=DocuEdge-Demo`
        window.open(this.url, "_blank");
      } else {
        alert("Unable to merge, Please contact the system administrator")
      }
    } else {
      alert("Please select 2 or more documents to merge")
    }
  }

  applyFilterOnCategories(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    if (this.filterValue.length > 0) {
      this.navBarCategories = []
      this.search()
    }
    else {
      this.categoryTreeData.data = this.categories
    }
  }

  search() {
    this.categories.filter(form => {
      if ((form.name.trim().toLowerCase().indexOf(this.filterValue.trim().toLowerCase()) > -1)) {
        this.navBarCategories.push(form)
      }
      if (form.sub_categories) {
        form.sub_categories.filter(element => {
          if ((element.name.trim().toLowerCase().indexOf(this.filterValue.trim().toLowerCase()) > -1)) {
            this.navBarCategories.push(form)
          }
        });
      }
      this.navBarCategories = this.navBarCategories.filter((elem, i, arr) => {
        if (arr.indexOf(elem) === i) {
          return elem
        }
      })
    })
    this.categoryTreeData.data = this.navBarCategories
  }

  applyFilter() {
    const filterValue = this.filterInput
    this.docResultsList.filter = filterValue.trim().toLowerCase();
    if (this.docResultsList.paginator) {
      this.docResultsList.paginator.firstPage();
      this.documentCount = this.docResultsList.filteredData.length
    }
  }

  clearFilter() {
    this.filterInput = ""
    this.docResultsList.filter = this.filterInput.trim().toLowerCase();
    if (this.docResultsList.paginator) {
      this.docResultsList.paginator.firstPage();
      this.documentCount = this.docResultsList.filteredData.length
    }
  }

  private getAllCategories() {
    this.categoryService.getAll().pipe(first()).subscribe(
      resp => {
        this.allCategories = resp['results'];
        this.getDisplayListData();
      }
    )
    this.categoryService.getTree()
      .pipe(first())
      .subscribe(
        categories => {
          let checkCategories:any = categories
          if (checkCategories == "No categories to display") {
            this.noCategories = true
          }
          else {
            this.noCategories = false;
            this.categories = categories;
            this.navBarCategories = categories
            this.categoryTreeData.data = categories
          }

        },
        error => {
        }
      );
  }

  openUploadForm(file) {
    if (file.length > 0) {
      this.fileToUpload = file[0]
      this.openUpload = true;
    }
  }

  previous() {
    this.offset = this.offset - 200
    this.selectCategory(this.categoryName, this.categoryId)
  }

  next() {
    this.offset = this.offset + 200
    this.selectCategory(this.categoryName, this.categoryId)
  }

  selectCategory(name, id) {
    this.filterInput = ""
    this.allCategories.find(x => {
      x.id == id; if (x.id == id) {
        this.category = x.id
        this.categoryPermissions = x.permissions
      }
    });

    this.disableUpload = true;
    this.disableDelete = true;
    let uploadGroups: string[] = this.categoryPermissions.add_document;
    let deleteGroups: string[] = this.categoryPermissions.delete_document;
    let isRestrictCatUploadApply: boolean = false;
    let isRestrictCatDeleteApply: boolean = false;

    if (!this.isAdmin) {

      for (var j = 0; j < uploadGroups.length; j++) {
        if (this.restrictUpdDelGrp.indexOf(uploadGroups[j]) > -1) {
          isRestrictCatUploadApply = true;
          break;

        }

      }
      for (var i = 0; i < deleteGroups.length; i++) {
        if (this.restrictUpdDelGrp.indexOf(deleteGroups[i]) > -1) {
          isRestrictCatDeleteApply = true;
          break;
        }
      }
      if (!isRestrictCatUploadApply && !isRestrictCatDeleteApply) {
        let userGroups: string[] = JSON.parse(localStorage.getItem("userGroups"));
        for (var j = 0; j < userGroups.length; j++) {
          for (var i = 0; i < uploadGroups.length; i++) {
            if (userGroups[j].indexOf(uploadGroups[i]) > -1) {
              this.disableUpload = false
              break;
            }
          }
          for (var i = 0; i < deleteGroups.length; i++) {
            if (userGroups[j].indexOf(deleteGroups[i]) > -1) {
              this.disableDelete = false
              break;
            }

          }
        }
      }
    } else {

      for (var j = 0; j < uploadGroups.length; j++) {
        if (this.restrictUpdDelGrp.indexOf(uploadGroups[j]) > -1) {
          isRestrictCatUploadApply = true;
          break;
        }
      }
      for (var i = 0; i < deleteGroups.length; i++) {
        if (this.restrictUpdDelGrp.indexOf(deleteGroups[i]) > -1) {
          isRestrictCatDeleteApply = true;
          break;
        }
      }
      if (!isRestrictCatUploadApply) {
        this.disableUpload = false;
      } 
      if (!isRestrictCatDeleteApply) {
        this.disableDelete = false;
      }      

    }
    this.selection.clear()
    this.documents = null;
    this.docResultsList = null;
    this.totalDocumentCount = 0;
    this.pageIndex = 0;
    this.pageSize = 50;
    this.offset = 0;
    this.openUpload = false;
    this.selectedDoc = null;
    this.navBarCategories.sort = this.sort
    this.documentCount = 0;
    this.selectedCategory = true;
    this.categoryId = id;
    this.categoryName = name;
    this.appError = null;
    this.loadNext = false;
    this.loadPrevious = false;
    this.documentCols = ["select"];   
    this.documentService.getByCategory(id, this.offset)
      .subscribe(
        documents => {
          if (typeof documents != "object") {
            this.noDocuments = true
          }
          else {
            this.noDocuments = false
            this.documents = documents;
            this.totalDocumentCount = documents.count
            if (!this.totalDocumentCount) {
              this.totalDocumentCount = documents.results.length
            }
            if (this.totalDocumentCount > (this.offset + 200)) {
              this.loadNext = true
            }
            if (this.offset >= 200) {
              this.loadPrevious = true
            }
            this.documentCount = this.documents.results.length;
            //Get dynamic document columns            
            var additionalCols: String[] = []
            this.selectedFormDisplayList.forEach(function (key) {
              if (key.visible) {
                additionalCols.push(key.name);
              }
            })

            for (var i = 0; i < additionalCols.length; i++) {
              this.documentCols.push(additionalCols[i])
            }
            this.documentCols.push("actionButton");
            this.docResultsList = new MatTableDataSource(this.documents.results);
            this.docResultsList.sort = this.sort;
            this.docResultsList.paginator = this.paginator;

            this.docResultsList.sortingDataAccessor = (item, property) => {
              var list = this.selectedFormDisplayList.filter((obj) => obj.name == property);
              if (list.length > 0) {
                var selectedItem = list[0];
                let value;
                switch(selectedItem["type"]) {
                  case 'original': return item[selectedItem["value"]];
                   case 'properties': value = item.metadata.properties[selectedItem["value"]];
                                      if (selectedItem["data_type"] === 'date'&& value != undefined) {
                                        return new Date(value);
                                      }
                                      else {
                                        return value;
                                      }
                  case 'system': return item.metadata.system[selectedItem["value"]];
                  default: return item[property];
                }
              } else {
                return null;
              }              
            };
          }
        })
  }



  selectPage(pageOptions) {
    this.pageIndex = pageOptions.pageIndex;
    this.pageSize = pageOptions.pageSize;
    let currentPageSize = this.pageSize;    
    this.currentStartPageIndex = (this.pageIndex * this.pageSize) + 1;
    currentPageSize = currentPageSize * (this.pageIndex + 1);
    if (currentPageSize >= this.documentCount && currentPageSize < this.totalDocumentCount) {
      this.offset += 200;
      this.getNextDocuments(this.categoryName, this.categoryId);
    }
    this.currentPageSize = currentPageSize;
  }

  getNextDocuments(name,id) {
    this.documentService.getByCategory(id, this.offset)
      .subscribe(
        documents => {
          if (typeof documents != "object") {
            // this.noDocuments = true
          }
          else {
            this.noDocuments = false
            documents.results.forEach(element => {
              this.documents.results.push(element);
            });
            this.totalDocumentCount = documents.count
            this.documentCount += documents.results.length            
            this.docResultsList = new MatTableDataSource(this.documents.results);
            this.docResultsList.sort = this.sort;
            this.docResultsList.paginator = this.paginator;

            this.docResultsList.sortingDataAccessor = (item, property) => {
              var list = this.selectedFormDisplayList.filter((obj) => obj.name == property);
              if (list.length > 0) {
                var selectedItem = list[0];
                let value;
                switch(selectedItem["type"]) {
                  case 'original': return item[selectedItem["value"]];
                   case 'properties': value = item.metadata.properties[selectedItem["value"]];
                                      if (selectedItem["data_type"] === 'date'&& value != undefined) {
                                        return new Date(value);
                                      }
                                      else {
                                        return value;
                                      }
                  case 'system': return item.metadata.system[selectedItem["value"]];
                  default: return item[property];
                }
              } else {
                return null;
              }              
            };
          }
        })
  }

  

  getDocDetails(event, docId, drawer, selectedElement) {
    if (drawer.opened) {
      drawer.toggle();
    }
    this.hideDocList = true;
    this.width = "50";
    this.selectedDoc = docId;
    this.selectDocument = selectedElement;
    //console.log(this.pageIndex)
  }

  back(hide: boolean) {
    if (hide) {
      this.openUpload = true
    }
    else {
      this.openUpload = false
      this.selectCategory(this.categoryName, this.categoryId);
    }
  }

  closeTabs(hide: boolean) {
    if (hide) {
      this.openMetaData = false
      this.openVersionUpload = false
    }
  }

  backFromMetaData(hide: boolean) {
    if (hide) {
      this.openMetaData = true;
    }
    else {
      this.openMetaData = false
      this.ngOnInit();
      //this.selectedDoc.VersionNumber = this.activeDocumentDetails.activeVersion + 1
    }
  }

  subscribe(docDetails) {
    this.selectDocument = docDetails
    this.selectedDoc = this.selectDocument.documentId
    this.fetchServiceData()
  }

  openUploadDocument() {
    this.openVersionUpload = true
    this.openMetaData = false
  }

  openUpdateMetaData() {
    this.openMetaData = true
    this.openVersionUpload = false
  }

  lockUnlockDocument(lockStatus) {
    this.isDocLocked = !this.activeDocumentDetails.locked
    if (lockStatus) {
      this.documentService.unlockDocument(this.selectedDoc)
        .subscribe(
          resp => {
            this.fetchServiceData()
            //this.ngOnInit()
          },
          error => {
            var errObj = JSON.parse(error.error)
            if (error.error['status'] = 400) {
              //this.appError = errObj.message
            }
          });

    } else {
      this.documentService.lockDocument(this.selectedDoc)
        .subscribe(
          resp => {
            this.fetchServiceData()
            //this.ngOnInit()
          },
          error => {
            var errObj = JSON.parse(error.error)
            if (error.error['status'] = 400) {
              //this.appError = errObj.message
            }
          });
    }
  }


  backFromUpload(hide: boolean) {
    if (hide) {
      this.openVersionUpload = true;
    }
    else {
      this.openVersionUpload = false
      this.selectDocument.VersionNumber = this.activeDocumentDetails.activeVersion + 1
      this.fetchServiceData()
    }
  }

  fetchServiceData() {
    this.hideDocView = true
    this.documentService.getDocumentDetails(this.selectedDoc)
      .subscribe(details => {
        this.hideDocView = false;
        this.activeDocumentDetails = details;
        this.isDocLocked = this.activeDocumentDetails.locked;
        if (details.locked == true && details.locked_by != this.currentUser.username) {
          this.isLockUser = true
        }
      });
  }

  openDialog() {
    let dialogRef = this.dialog.open(DialogUploadfileComponent,
      { data: { categoryID: this.categoryId } });

    dialogRef.afterClosed().subscribe(result => {
      this.selectCategory(this.categoryName, this.categoryId);
    });
  }

  exportDocuments() {
    console.log("DocumentIDs", this.selection.selected.join());
    var request = {
      "docid": this.selection.selected.join().split(",")
    }
    this.selection.clear();
    this.documentService.exportDocuments(request).subscribe(
      response => {
        console.log("Response " + response);
      });
  }

  onHideDocList(hide: boolean) {
    //console.log("inside emit");
    if (hide) {
      this.hideDocList = true;
    } else {
      this.hideDocList = false;
      this.selection.clear();
      this.drawerContainer.open();
      this.selectCategory(this.categoryName, this.categoryId)
    }
  }

  async sendDocsForRedaction() {
    this.allSelectedDocuments.forEach(element => {
      this.documentService.getDocumentDetails(element)
        .subscribe(details => {
          let activeDocumentDetails = details;
          var updateReq = {
            "docId": activeDocumentDetails.documentId,
            "category_id": activeDocumentDetails.categoryId,
            "properties": {}
          }
          var props = cloneDeep(activeDocumentDetails['metadata']['properties']);
          updateReq.properties = props;
          const docType = activeDocumentDetails['metadata']['system']['type'];

          let isDocumentRedactable: Boolean = false;
          let isDocAlreadyRedacted: Boolean = false;
          let isDocRedactionEnabled: Boolean = false;
          activeDocumentDetails['categoryMetaData']['properties'].forEach(prop => {
            if (prop.name == 'Enable Redaction') {
              isDocumentRedactable = true;
              isDocAlreadyRedacted = activeDocumentDetails.documentName.toLowerCase().includes('redacted') || props['Enable Redaction'] ? true : false;
              isDocRedactionEnabled = props['Enable Redaction'] ? true : false;
            }
          })
          if (isDocumentRedactable && docType && (docType.includes('pdf') || docType.includes('png') || docType.includes('jpg') || docType.includes('jpeg'))) {
            if (!isDocRedactionEnabled) {
              updateReq.properties['Enable Redaction'] = true;
              this.documentService.updateDocumentMetadata(updateReq)
                .subscribe(
                  resp => {
                    // this.updateMessage = true;
                    // this.toggleUpdate = false;

                    var payload = {
                      "docID": activeDocumentDetails.documentId,
                      "asynchProcess": '1',
                    }

                    const res = this.documentService.sendDocumentForRedaction(payload).toPromise();
                    console.log("Document Metadata updated and Sent For Redaction!");
                    console.log(resp);
                  }
                ),
                error => {
                  this.alertService.error(error);
                }
            } else {
              this.tempMessage = 'Document is already redacted!';
              this.dialog.open(this.redactionPopup,
                { width: '500px' });
              console.log('Document is already redacted!');
            }
          } else {
            if (docType && (!docType.includes('pdf') && !docType.includes('png') && !docType.includes('jpg') && !docType.includes('jpeg'))) {
              this.tempMessage = 'Document cannot be sent for redaction!';
              this.dialog.open(this.redactionPopup,
                { width: '500px' });
              console.log(props['Enable Redaction'] + ': Document cannot be sent for redaction');
            } else {
              var payload = {
                "docID": activeDocumentDetails.documentId,
                "asynchProcess": '1',
              }
              const res = this.documentService.sendDocumentForRedaction(payload).toPromise();
            }
          }
        });
    });
  }

  async sendDocsForRedactionWithoutAnyChecks() {
    this.allSelectedDocuments.forEach(element => {
      var payload = {
        "docID": element,
        "asynchProcess": '1',
      }

      const res = this.documentService.sendDocumentForRedaction(payload).toPromise();
    });
  }
  deleteDocuments() {
    if (this.selection.selected.length > 0) {
      let dialogRef = this.dialog.open(DialogDeleteConfirmComponent,
        { width: '500px', data: { type: "Delete Documents", payload: this.selection.selected } });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.refresh();
        }
      })
    } else {
      alert("Please select 1 or more files to be deleted")
    }
  }
  refresh() {
    this.selectCategory(this.categoryName, this.categoryId);
  }

  // onHideDocListWithCategoryChange(hide: boolean, categoryName, categoryID) {
  //   console.log("inside onHideDocListWithCatChange " + hide + " : " +  categoryName + " : " + categoryID);
  //   if (hide) {
  //     this.hideDocList = true;
  //   } else {
  //     this.hideDocList = false;
  //     this.selection.clear();
  //     this.drawerContainer.open();
  //     //this.selectCategory(this.categoryName, this.categoryId)
  //     this.selectCategory(categoryName, categoryID)
  //   }
  // }
  // getCatName(catName:string){
  //   if(catName){
  //     this.fetchedCategoryName=(catName)
  //   }
  // }

  // getCatID(catID:any){
  //   if(catID){
  //     this.fetchedCategoryID=(catID)
  //   }
  // }

}